
varying vec2 vUv;

void main() {
  vUv = uv;
}